import React from "react";

const SnapshotMetric = ({ label, value, detail }) => (
  <div className="rounded-2xl border border-slate-200/70 bg-slate-50/80 p-4 transition hover:bg-white hover:shadow-sm">
    <p className="text-3xl font-semibold tracking-tight text-slate-950">
      {value}
    </p>
    <p className="mt-1 text-sm font-semibold text-slate-800">{label}</p>
    {detail && (
      <p className="mt-1 text-xs leading-5 text-slate-500">{detail}</p>
    )}
  </div>
);

const TodaysCareSnapshot = ({ summary, isLoading, onViewDailyActivity }) => {
  const taskValue = summary?.taskTotal
    ? `${summary.taskCompleted}/${summary.taskTotal}`
    : summary?.taskCompleted || 0;
  const taskDetail =
    summary?.nextIncompleteTask ||
    (summary?.taskCompleted > 0
      ? "Completed tasks recorded today"
      : "No task items recorded");

  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white/95 p-5 shadow-sm md:p-6">
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
            Daily Summary
          </p>
          <h2 className="mt-1 text-2xl font-semibold tracking-tight text-slate-950">
            Today&apos;s Care Snapshot
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            A grouped view of today&apos;s recorded care activity.
          </p>
        </div>
        <button
          type="button"
          onClick={onViewDailyActivity}
          className="inline-flex min-h-10 items-center justify-center rounded-full bg-slate-100 px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-200"
        >
          View Activity
        </button>
      </div>

      {isLoading ? (
        <div className="rounded-2xl bg-slate-50 p-4 text-sm text-slate-500">
          Loading today&apos;s care snapshot...
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
          <SnapshotMetric
            label="Vitals"
            value={summary?.vitalsCount || 0}
            detail={summary?.latestVitalsLabel || "No vitals today"}
          />
          <SnapshotMetric
            label="Meds Administered"
            value={summary?.medicationCount || 0}
            detail={
              summary?.latestMedicationLabel || "No administrations today"
            }
          />
          <SnapshotMetric
            label="Tasks Done"
            value={taskValue}
            detail={taskDetail}
          />
          <SnapshotMetric
            label="Notes"
            value={summary?.noteCount || 0}
            detail="Observation notes today"
          />
          <SnapshotMetric
            label="Incidents"
            value={summary?.incidentCount || 0}
            detail={
              summary?.incidentCount > 0
                ? "Review recent incident details"
                : "No incidents today"
            }
          />
          <SnapshotMetric
            label="Care Records"
            value={summary?.dailyCareCount || 0}
            detail={summary?.latestCareLabel || "No daily care record today"}
          />
        </div>
      )}
    </section>
  );
};

export default TodaysCareSnapshot;
